import React, { useEffect, useState } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import withStyles from '@material-ui/core/styles/withStyles';
import styled from 'styled-components';
import * as paidTier from 'selectors/paidTier';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { ClickAwayListener, makeStyles, Tooltip } from '@material-ui/core';
import ClickDropDown from 'components/UI/ClickDropDown';
import CohereIcon from 'assets/coherelogo.png';
import DummyImage from 'assets/CrousalItem1.png';
import { FormControlLabel } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import classes from './Contact.module.scss';
import DropDownList from 'components/UI/DropDownList/DropDownList';
import { Link } from 'react-router-dom';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { colors } from 'utils/styles';
import ChatButton from 'components/UI/ListButtons/ChatButton';
import { IconButton } from '@material-ui/core';
import NoteIcon from 'pages/ClientPage/components/NoteIcon';
import Avatar from '@material-ui/core/Avatar';
import { getInitialSymbol } from 'components/UI/Header';
import moment from 'moment';
import { addhttp } from 'utils/utils';
import useRouter from 'hooks/useRouter';
import Modal from 'components/UI/Modal';
import DeleteContactModal from 'pages/Contacts/Leads/LeadModals/DeleteContactModal';
import AddContactTagModal from 'pages/Contacts/Leads/LeadModals/AddContactTagModal';
import Portal from 'components/UI/Portal';
import CrossableTag from 'pages/Contacts/Components/CrossableTag/CrossableTag';
import { ContactsServices } from 'pages/Contacts/Services/Contacts.service';
import Loader from 'components/UI/Loader';
import { fetchAllContactsAsync, setContacts } from 'actions/contacts';
import { useDispatch, useSelector } from 'react-redux';
import { setSendEmailTo } from 'actions/campaign';
import { setCampaignNotification } from 'actions/campaign';
import useCampaign from 'pages/CreateCampaign/Hooks/useCampaign';
import Notification from 'pages/CreateCampaign/Components/Notification/Notification';
import { isEmpty } from 'lodash';
import { TOOLTIP } from '../../../../constants';
import useShallowEqualSelector from 'hooks/useShallowEqualSelector';

const StyledDropDownWrapper = styled.div`
  position: relative;
`;

const StyledDate = styled.div`
  width: 130px;
`;

const StyledType = styled.div`
  border-radius: 5px;
  padding: 2px 8px;
  color: #215c73;
  border: 1.5px solid #215c73;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.23999999463558197px;
  // text-align: left;
`;

const TagsContainer = styled.div`
  width: 125px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  //   flex-wrap: wrap;
  gap: 5px;
`;

const StyledTag = styled.div`
  height: 27px;
  // min-width: 100px;
  border-radius: 5px;
  padding: 2px 15px;
  color: white;
  background-color: ${colors.newGold};
  border: 1.5px solid ${colors.newGold};
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.23999999463558197px;
  text-align: left;
`;

const AvatarComponent = styled(Avatar)`
  ${({ mobileView }) => {
    return (
      mobileView &&
      `
        width: 24px;
        height: 24px;
        font-size: 0.7rem;
      `
    );
  }}
`;

const StyledDropDownItem = styled(Link)`
  font-family: Avenir;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #4a4a4a;
  text-decoration: none;
  white-space: nowrap;
  background-color: white;
  padding: 8px 20px;
  border-bottom: 1px solid #f0f0f0;
  min-width: 100px;
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;
  text-align: left;

  ${({ isDisabled }) =>
    isDisabled &&
    `
    opacity: 1;
    color: gray;
    pointer-events: none;
    cursor: not-allowed;
  
  `}

  &:hover {
    text-decoration: underline;
  }
`;

const NarrowTableCell = withStyles({
  root: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 10,
    paddingRight: 10,
    borderBottom: 0,
  },
})(TableCell);

const AdditionalTagsCount = styled.div`
  font-weight: 600;
  color: #215c73;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const NarrowTableCellName = withStyles({
  root: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingRight: 0,
    borderBottom: 0,
  },
})(TableCell);

const StyledImage = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #dfe3e4;
`;

const StyledDropDown = styled.div`
  position: absolute;
  width: auto;
  top: ${({ top }) => (top ? top : '0px')};
  left: ${({ left }) => (left ? left : '0px')};
  z-index: 100;
  box-shadow: 0px 6px 30px 0px rgba(33, 92, 115, 0.32);
`;
const TooltipText = 'There are no clients for this service yet';
export const TRIAL_PERIOD_START_DATE = '2021-11-01';
export const TRIAL_PERIOD_DAYS = 13;

const Contact = ({
  index,
  row,
  isChecked,
  onCheckClicked,
  contactWithOpenDropDown,
  setId,
  setOpenNotesOf,
  totalCount,
}) => {
  const dispatch = useDispatch();
  const { contacts } = useSelector(state => state.contacts);
  const { domain, location, history } = useRouter();
  const activePaidTierPlan = useShallowEqualSelector(paidTier.activePaidTierPlanSelector);
  const showIntroPageDisable =
    activePaidTierPlan?.isEmailCampaignEnabled === false || activePaidTierPlan?.isEmailCampaignEnabled === undefined;
  const contributionURL =
    row.isContribution === false
      ? `/lead-magnet-view/${row?.recenetContributionId}/landingpage`
      : `/contribution-view/${row?.recenetContributionId}/about`;
  const formatter = new Intl.NumberFormat('en-US');
  const revenue = `${
    row?.currencySymbol === 'R' ? '$' : row?.currencySymbol === null ? '$' : row?.currencySymbol
  }${formatter.format(Math.floor(row?.revenueEarned))}`;
  const joinedOn = moment(row?.joinDate).format('MMMM DD, YYYY');
  const fullName = `${row?.firstName} ${row?.lastName}`;
  const firstTagName =
    !Array.isArray(row?.tags) || row?.tags?.length === 0
      ? ''
      : row?.tags[0]?.name?.length > 7
      ? row?.tags[0]?.name?.substring(0, 7) + '...'
      : row?.tags[0]?.name;
  const [isClientToLeadModalOpen, setIsClientToLeadModalOpen] = useState(false);
  const [isLeadToClientModalOpen, setIsLeadToClientModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isRemovingtag, setIsRemovingtag] = useState(false);
  const [addTagModalOpen, setAddTagModalOpen] = useState(false);
  const [isTagModalOpen, setIsTagModalOpen] = useState(false);
  const [removedTags, setRemovedTags] = useState(false);

  const [isUnderstandChecked, setIsUnderstandChecked] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  const clickAwayHandler = () => {
    setId(null);
  };

  useEffect(() => {
    if (contactWithOpenDropDown === null) {
      window.removeEventListener('click', clickAwayHandler);
    }
  }, [contactWithOpenDropDown]);

  const handleShowTags = () => {
    setIsTagModalOpen(true);
  };
  const handleConvertClick = () => {
    if (row?.isLead) {
      setIsLeadToClientModalOpen(true);
    } else {
      setIsClientToLeadModalOpen(true);
    }
  };

  const openMailClient = () => {
    window.location.href = `mailto:${row?.email}`;
  };

  const handleSendMail = () => {
    const data = [row];
    dispatch(setSendEmailTo(data));
    history.push('/create-campaign/title');
  };

  const handleDeleteClick = () => {
    setIsDeleteModalOpen(true);
  };

  const handleAddTagClick = () => {
    setAddTagModalOpen(true);
  };

  const goToViewPage = () => {
    if (row.isLead) {
      history.push(`/lead/${row.id}`);
    } else {
      history.push(`all/${row?.id}/${fullName}/${row?.email}`);
    }
  };

  return (
    <>
      <TableRow className={classes.container}>
        <NarrowTableCellName component="th" scope="row" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <FormControlLabel
            style={{ fontFamily: 'Avenir', marginRight: '5px', marginBottom: '0px' }}
            checked={isChecked(row?.id)}
            onChange={() => {
              onCheckClicked(row.id);
            }}
            control={<Checkbox color="primary" />}
            label={<></>}
            name="selected"
            disabled={false}
          />
          <AvatarComponent alt={`${row.firstName} ${row.lastName}`} src={row?.avatarUrl}>
            {`${row?.firstName && getInitialSymbol(row?.firstName)}${row?.lastName && getInitialSymbol(row?.lastName)}`}
          </AvatarComponent>
          <div
            style={{ width: '125px', cursor: row?.isImported ? 'default' : 'pointer', fontWeight: 'bold' }}
            onClick={row.isImported ? () => {} : goToViewPage}
          >
            {fullName}
          </div>
        </NarrowTableCellName>
        <Tooltip title={row?.email} arrow enterTouchDelay={TOOLTIP.ENTER_DELAY} leaveTouchDelay={TOOLTIP.LEAVE_DELAY}>
          <NarrowTableCell>{row?.email.length > 20 ? row?.email.slice(0, 20) + '...' : row?.email}</NarrowTableCell>
        </Tooltip>
        {row?.recenetContributionId === null && row.isImported ? (
          <Tooltip
            title={row?.source}
            arrow
            enterTouchDelay={TOOLTIP.ENTER_DELAY}
            leaveTouchDelay={TOOLTIP.LEAVE_DELAY}
          >
            <NarrowTableCell style={{ fontWeight: 'bold' }}>
              {row?.source.length > 10 ? row?.source.slice(0, 10) + '...' : row?.source}
            </NarrowTableCell>
          </Tooltip>
        ) : (
          <Tooltip
            title={row?.contributionTitle}
            arrow
            enterTouchDelay={TOOLTIP.ENTER_DELAY}
            leaveTouchDelay={TOOLTIP.LEAVE_DELAY}
          >
            <NarrowTableCell style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
              <Link to={contributionURL}>
                {' '}
                {row?.contributionTitle?.length > 10
                  ? row?.contributionTitle.slice(0, 10) + '...'
                  : row?.contributionTitle}
              </Link>
            </NarrowTableCell>
          </Tooltip>
        )}
        <NarrowTableCell>{revenue}</NarrowTableCell>
        <NarrowTableCell>
          <StyledDate>{joinedOn}</StyledDate>
        </NarrowTableCell>
        <NarrowTableCell>
          {Array.isArray(row?.tags) && row?.tags?.length > 0 ? (
            <TagsContainer>
              <Tooltip title={row?.tags[0]?.name} arrow>
                <StyledTag>{firstTagName}</StyledTag>
              </Tooltip>
              {row?.tags?.length > 1 && (
                <AdditionalTagsCount onClick={handleShowTags}>+{row?.tags?.length - 1}</AdditionalTagsCount>
              )}
            </TagsContainer>
          ) : (
            '-'
          )}
        </NarrowTableCell>
        <NarrowTableCell align="center">
          <StyledType>{row?.isLead ? 'Lead' : 'Client'}</StyledType>
        </NarrowTableCell>
        <NarrowTableCell align="center">
          {row?.chatSid != null ? (
            <ChatButton
              className="icon-button"
              handleClick={() => {
                history.push(`/conversations/all`, {
                  preferredConversationId: row?.chatSid,
                });
                // window.location.href = addhttp(domain.concat(`/conversations/all?chatId=${row?.chatSid}`));
              }}
            />
          ) : (
            <div>-</div>
          )}
        </NarrowTableCell>
        <NarrowTableCell align="center">
          <IconButton
            className="icon-button"
            onClick={() => {
              setOpenNotesOf(row?.id);
            }}
          >
            <NoteIcon fillColor="#215C73" />
          </IconButton>
        </NarrowTableCell>
        <NarrowTableCell align="center">
          <StyledDropDownWrapper>
            <MoreHorizIcon
              style={{ cursor: 'pointer' }}
              onClick={e => {
                e.stopPropagation();
                const rect = e.currentTarget.getBoundingClientRect();
                const scrollTop = window.scrollY || document.documentElement.scrollTop;
                const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
                setDropdownPosition({ top: rect.bottom + scrollTop, left: rect.left + scrollLeft - 160 });
                if (contactWithOpenDropDown === row?.id) {
                  setId(null);
                } else {
                  setId(row?.id);
                }
                window.removeEventListener('click', clickAwayHandler);
                window.addEventListener('click', clickAwayHandler);
              }}
            />
            {contactWithOpenDropDown === row?.id && (
              <Portal>
                <StyledDropDown top={`${dropdownPosition.top}px`} left={`${dropdownPosition.left}px`}>
                  {row.isImported === false && (
                    <div>
                      <StyledDropDownItem onClick={goToViewPage}>View</StyledDropDownItem>
                    </div>
                  )}
                  <div>
                    <StyledDropDownItem onClick={handleConvertClick}>
                      Convert to {row?.isLead ? 'Client' : 'Lead'}
                    </StyledDropDownItem>
                  </div>
                  <div>
                    <StyledDropDownItem isDisabled={showIntroPageDisable} onClick={handleSendMail}>
                      Send Email
                    </StyledDropDownItem>
                  </div>

                  <div>
                    <StyledDropDownItem onClick={handleAddTagClick}>Add Tag</StyledDropDownItem>
                  </div>
                  <div>
                    <StyledDropDownItem onClick={handleDeleteClick}>Delete</StyledDropDownItem>
                  </div>
                </StyledDropDown>
              </Portal>
            )}
          </StyledDropDownWrapper>
        </NarrowTableCell>
      </TableRow>

      <Modal
        title="Convert Client to Lead"
        isOpen={isClientToLeadModalOpen}
        onCancel={() => {
          setIsClientToLeadModalOpen(false);
        }}
        onSubmit={() => {
          const data = {
            contactId: row?.id,
            isLead: true,
          };
          ContactsServices.updateContact(data)
            .then(res => {
              setIsClientToLeadModalOpen(false);
              dispatch(
                setCampaignNotification({
                  heading: row?.isLead ? 'Lead Converted Successfully' : 'Client Converted Successfully',
                  message: `You have successfully converted ${row?.isLead ? 'Lead' : 'Client'}`,
                }),
              );
              setTimeout(() => {
                dispatch(setCampaignNotification(''));
              }, 8000);
              dispatch(fetchAllContactsAsync({}));
            })
            .catch(err => {});
        }}
        submitTitle="Convert"
        reduceCancelButton
        widthRequired
      >
        <div className="pb-15">
          Are you sure you want to convert your Client to Lead? By doing this they will now appear in your Lead’s list.
        </div>
      </Modal>

      <Modal
        title="Convert Lead to Client"
        isOpen={isLeadToClientModalOpen}
        onCancel={() => {
          setIsLeadToClientModalOpen(false);
        }}
        onSubmit={() => {
          const data = {
            contactId: row?.id,
            isLead: false,
          };
          ContactsServices.updateContact(data)
            .then(res => {
              setIsLeadToClientModalOpen(false);
              dispatch(
                setCampaignNotification({
                  heading: row?.isLead ? 'Lead Converted Successfully' : 'Client Converted Successfully',
                  message: `You have successfully converted ${row?.isLead ? 'Lead' : 'Client'}`,
                }),
              );
              setTimeout(() => {
                dispatch(setCampaignNotification(''));
              }, 8000);
              dispatch(fetchAllContactsAsync({}));
            })
            .catch(err => {
              setTimeout(() => {
                dispatch(setCampaignNotification(''));
              }, 8000);
            });
        }}
        submitTitle="Convert"
        reduceCancelButton
        widthRequired
      >
        <div className="pb-15">
          Are you sure you wish to convert your lead to a client. By doing this it'll now appear in your clients list.
          You can always revert this again.
        </div>
      </Modal>

      <Modal
        title="Delete Contact(s)"
        isOpen={isDeleteModalOpen}
        onCancel={() => {
          setIsDeleteModalOpen(false);
        }}
        onSubmit={() => {
          setIsDeleting(true);
          ContactsServices.deleteContact([row.id])
            .then(res => {
              setIsUnderstandChecked(false);
              setIsDeleteModalOpen(false);
              dispatch(fetchAllContactsAsync({}));
            })
            .catch(err => {})
            .finally(() => {
              setIsDeleting(false);
            });
        }}
        disableSubmitClick={!isUnderstandChecked || isDeleting}
        submitTitle="Delete"
        reduceCancelButton
      >
        <DeleteContactModal
          contacts={[row.id]}
          checkboxValue={isUnderstandChecked}
          onCheckboxChange={() => {
            setIsUnderstandChecked(!isUnderstandChecked);
          }}
        />
      </Modal>

      {addTagModalOpen && (
        <AddContactTagModal
          contacts={[row]}
          contactsList={contacts.map(c => ({ title: `${c.firstName} ${c.lastName}`, value: c.id }))}
          isOpen={addTagModalOpen}
          onClose={() => {
            setAddTagModalOpen(false);
          }}
        />
      )}

      <Modal
        title="All Tags"
        isOpen={isTagModalOpen}
        onCancel={() => {
          setRemovedTags(false);
          setIsTagModalOpen(false);
          if (removedTags) {
            dispatch(fetchAllContactsAsync({}));
          }
        }}
        disableFooter
        widthRequiredIs
        minHeight="0px"
      >
        <div className={classes.all_tags_container}>
          {isRemovingtag && <Loader />}
          {row?.tags?.map(tag => {
            return (
              <CrossableTag
                tagName={tag?.name}
                onCross={() => {
                  const data = {
                    tagId: tag?.id,
                    contactId: row?.id,
                  };
                  setIsRemovingtag(true);
                  ContactsServices.removeTagFromUser(data)
                    .then(() => {
                      const payload = {
                        ...row,
                        tags: row.tags.filter(t => t.id != tag.id),
                      };
                      dispatch(setContacts(payload));
                      setIsRemovingtag(false);
                      setRemovedTags(true);
                      if (row?.tags?.length - 1 === 0) {
                        setIsTagModalOpen(false);
                        dispatch(fetchAllContactsAsync({}));
                      }
                    })
                    .catch(() => {
                      setIsRemovingtag(false);
                    });
                }}
              />
            );
          })}
        </div>
      </Modal>
    </>
  );
};

Contact.propTypes = {};

Contact.defaultProps = {};

export default Contact;
